import { RedplusTariff } from '@vfde-sails/constants';
import { TariffCards } from '@vfde-brix/ws10/tariff-card';

/**
 * Get available subscription IDs from DOM
 */
const getAvailableSubscriptionIds = (tariffCards: TariffCards | null): RedplusTariff[] => tariffCards?.getAllPossibleIds() || [];

export default getAvailableSubscriptionIds;
